import { Schedule } from '@root/globalTypes';
import { UsersSchedules } from '@services/schedules/internal/types';
import { WorkloadBasicForeman } from '@services/workload/calendar/types';
import { parseISO } from 'date-fns';

export const toForeman = ({
  id,
  fullName,
  discardedAt,
  crewMembers,
  specialties,
}: UsersSchedules): WorkloadBasicForeman => ({
  id,
  fullName,
  discardedAt,
  crewMembers,
  specialties: specialties.map(({ name, value }) => ({ name, value })),
});

const range = ({ startsAt, endsAt }: Schedule) => [+parseISO(startsAt), +parseISO(endsAt)];

export const hasConflict = (current: Schedule | undefined, schedules: Schedule[]) => {
  if (!current) return false;
  const [start, end] = range(current);
  return schedules.some((item) => {
    const [itemStart, itemEnd] = range(item);
    return itemStart < end && start < itemEnd;
  });
};
